module.exports = __webpack_public_path__ + "img/img-mine.6c5462f3.jpg";